type DecimalSelectProps = {
    max?: number | string;
    value?: number;
    showValidations?: boolean;
    onClickValue: (value: number) => void;
    className?: string;
};

export default function DecimalSelect(props: DecimalSelectProps) {
    var options = [];
    const max = props.max !== undefined ? Number(props.max) : 10;
    const currentValue = Number(props.value ?? 0);
    const inValid = !!props.showValidations
        && (!Number.isFinite(currentValue) || currentValue < 1 || currentValue > max);
    for (let i = 1; i <= max; i++) {
        options.push(
            <span key={i} 
                className={`numberSelect value${i}${currentValue === i ? ' selected' : ''}`}
                onClick={() => { props.onClickValue(i) }}>{i}
            </span>);
    }
    return (<div className={`decimalSelect ${props.showValidations && inValid ? 'invalid':''}${props.className ? ` ${props.className}` : ''}`}>
        {options}
    </div>
    );
}
